var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63481 0.055093C1.62736 0.055093 0 1.50877 0 3.30198V20.7974C0 22.5906 1.62736 24.0442 3.63481 24.0442H13.3505C13.3505 16.0462 13.3505 8.04807 13.3505 0.0499878L3.63481 0.055093Z",
    fill: "#0038A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3391 0.055603C13.3391 8.05369 13.3391 16.0518 13.3391 24.0499H26.6839C26.6839 16.0518 26.6839 8.05369 26.6839 0.055603H13.3391Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3652 0.055603H26.6781C26.6781 8.05369 26.6781 16.0518 26.6781 24.0499H36.3652C38.3727 24.0499 40 22.5962 40 20.803V3.30759C40.0015 2.44558 39.6192 1.61841 38.9374 1.0084C38.2556 0.398384 37.3302 0.055602 36.3652 0.055603Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFra);
export default __webpack_public_path__ + "static/media/FRA.6a3ac6e957b7eb87fbf34ec6e952cd22.svg";
export { ForwardRef as ReactComponent };